import { find } from 'lodash-es'
import { DealerAPI } from 'src/api'
import $router from 'src/router'
import { useCustomGroup } from 'pages/CustomGroups/composables/useCustomGroup.js'

export default {
  namespaced: true,
  state: {
    dealers: [],
  },
  mutations: {
    SET_DEALERS(state, payload) {
      state.dealers = payload
    },
  },
  actions: {
    async list({ commit }) {
      const data = await DealerAPI.getList()
      commit('SET_DEALERS', data)
      return data
    },
  },
  getters: {
    allDealership() {
      return {
        id: 0,
        name: 'All Dealerships',
      }
    },
    dealer(state, getters, rootState) {
      const dealers = state.dealers || []
      const dealer = find(dealers, {
        id: +rootState.settings.dealerGroupId,
      })

      // if (dealer !== undefined) {
      //   dealer.castUnknownLeadsAs = 'unknown'
      // }

      return dealer
    },
    currentDealerships(state, getters, rootState) {
      return +rootState.settings.dealerShipId === 0
        ? getters.dealerships.map((e) => +e.id)
        : rootState.settings.dealerShipId.split(',').map(Number)
    },
    dealerships(state, getters) {
      if ($router.currentRoute.value.meta.customGroup) {
        const { customGroup } = useCustomGroup()
        return customGroup.value?.allDealerships ?? []
      }

      let dealerships = []
      if (getters.dealer) {
        dealerships = getters.dealer.dealerships.map((item) => ({
          ...item,
          title: item.name,
        }))
      }
      return dealerships
    },
    dealershipsList(state, getters) {
      return [getters.allDealership, ...getters.dealerships]
    },
    budgetCampaignView(state, getters, rootState) {
      if (state.dealers) {
        const dealer = find(state.dealers, {
          id: +rootState.settings.dealerGroupId,
        })

        return dealer.budgetCampaignView
      }

      return 0
    },
  },
}
